export function HonoIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"  fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="#FF5B11"
        d="M8.24.016a.14.14 0 0 1 .112.032 60.664 60.664 0 0 1 3.36 4.512 22.107 22.107 0 0 1 1.984 3.712c.871 2.323.418 4.345-1.36 6.064-1.556 1.315-3.347 1.827-5.376 1.536-2.425-.494-4.073-1.897-4.944-4.208a5.892 5.892 0 0 1-.224-2.304c.13-1.349.45-2.65.96-3.904.213-.512.49-.98.832-1.408.279.332.546.673.8 1.024.118.123.24.24.368.352A30.226 30.226 0 0 1 8.24.016Z"
        opacity=".993"
      />
      <path
        fill="#FF9758"
        d="M8.016 2.608A33.832 33.832 0 0 1 11.2 6.96c.297.51.543 1.043.736 1.6.403 1.584-.03 2.89-1.296 3.92-1.225.862-2.57 1.118-4.032.768-1.578-.49-2.49-1.55-2.736-3.184a3.389 3.389 0 0 1 .16-1.504c.237-.603.525-1.179.864-1.728l.96-1.408c.727-.935 1.447-1.873 2.16-2.816Z"
      />
    </svg>
  );
}
